import React from "react";
import ApiRequest from "./common/restservice";
import { errorToast } from "./common/showtoast";
import PageHeader from "./common/pageheader";

export default class KYCBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      MemberID: "",
      FullName: "",
      Account_Number: "",
      Bank_name: "",
      Branch_Name: "",
      IFSC: "",
      bankstatus: "",
      bank_approve: ""
    }
  }
  componentDidMount() {
    this.GetDashboardDetails();
  }
  async GetDashboardDetails() {
    let res = await ApiRequest("MyProfile.asp", "GET", null, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState(res);
  }
  render() {
    return (
      <div>
        <PageHeader title="Convert Wallet" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
            <div className="card overflow-hidden dash1-card border-0 ">
              <div className="card-body">
                <h3 className=" mt-3 mb-3 text-center">Bank Details</h3>
                <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                  <tr>
                    <td>Username</td>
                    <td>
                      <h6>{this.state.MemberID}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">Fullname</td>
                    <td className="mt-2">
                      <h6>{this.state.FullName}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">Bank Name</td>
                    <td className="mt-2">
                      <h6>{this.state.Bank_name}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">Branch Name</td>
                    <td className="mt-2">
                      <h6>{this.state.Branch_Name}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">Account Number</td>
                    <td className="mt-2">
                      <h6>{this.state.Account_Number}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">IFSC</td>
                    <td className="mt-2">
                      <h6>{this.state.IFSC}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td className="mt-2">Status</td>
                    <td className="mt-2">
                      <button className={`btn ${this.state.bank_approve ? "btn-color-1" : "btn-color-2"}`}> {this.state.bank_approve ? "Approved" : "Pending"}</button>
                    </td>
                  </tr>

                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}